package ui.screens.section.gallery

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.zIndex
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource
import ui.theme.ColorScheme

@Composable
fun ParallaxImages(
    parallaxProgress: Float,
    topImagePath: DrawableResource,
    bottomImagePath: DrawableResource,
) {

    Box(
        Modifier
            .padding(16.dp)
            .widthIn(max = 400.dp)
            .fillMaxWidth()
            .height(700.dp),
        contentAlignment = Alignment.Center,
    ) {
        Image(
            painterResource(topImagePath),
            contentDescription = null,
            contentScale = ContentScale.Crop,
            modifier = Modifier.align(Alignment.TopEnd)
                .zIndex(1f).height(400.dp)
                .fillMaxWidth(0.7f)
                .graphicsLayer {
                    translationY = parallaxProgress * 500
                }
                .clip(RoundedCornerShape(topStartPercent = 100, topEndPercent = 100))
        )
        Image(
            painterResource(bottomImagePath),
            contentDescription = null,
            contentScale = ContentScale.Crop,
            modifier = Modifier.align(Alignment.BottomStart)
                .zIndex(1f)
                .graphicsLayer {
                    translationY = -(parallaxProgress * 400)
                }
                .clip(
                    RoundedCornerShape(
                        bottomStartPercent = 100,
                        bottomEndPercent = 100
                    )
                ).height(300.dp)
                .fillMaxWidth(0.6f)
        )
    }
}

@Composable
fun RomanticGalleryButton(
    text: String,
    onClick: () -> Unit,
) {
    Button(
        onClick = onClick,
        shape = RoundedCornerShape(50),
        colors = ButtonDefaults.buttonColors(
            containerColor = Color.Transparent,
            contentColor = Color.White
        ),
        contentPadding = PaddingValues(),
        elevation = ButtonDefaults.buttonElevation(
            defaultElevation = 0.dp,
            pressedElevation = 0.dp,
            focusedElevation = 0.dp,
            hoveredElevation = 0.dp,
            disabledElevation = 0.dp
        )
    ) {
        Box(
            modifier = Modifier
                .background(
                    brush = Brush.horizontalGradient(
                        listOf(
                            ColorScheme.primary,
                            ColorScheme.primary
                        )
                    ),
                    shape = RoundedCornerShape(50)
                )
                .padding(horizontal = 20.dp, vertical = 10.dp)
        ) {
            Text(
                text = text,
                fontSize = 16.sp
            )
        }
    }
}